import React, { useState, useEffect, useCallback, useMemo } from "react";
import styles from "./UserManagement.module.css";
import { CustomPagination, CustomTable } from "../../components";
import { AxiosInstance } from "../../services/Api";

const School = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Pagination
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const fetchSchools = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await AxiosInstance.get("/school/list");

      if (response.data?.success && response.data.data) {
        setSchools(response.data.data);
      } else {
        throw new Error(response.data?.message || "Failed to fetch schools");
      }
    } catch (err) {
      console.error("Error fetching schools:", err);
      setError(err.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchSchools();
  }, [fetchSchools]);

  const paginatedSchools = useMemo(() => {
    const start = (page - 1) * limit;
    return schools.slice(start, start + limit);
  }, [schools, page, limit]);

  const columns = useMemo(
    () => [
      { key: "id", label: "ID", width: "60px" },
      { key: "school_name", label: "SCHOOL NAME", minWidth: "200px" },
      { key: "school_email", label: "SCHOOL EMAIL", minWidth: "220px" },
      {
        key: "address",
        label: "ADDRESS",
        minWidth: "200px",
        render: (_, row) => {
          const parts = [row.address1, row.address2, row.address3].filter(
            Boolean
          );
          return parts.join(", ") || "-";
        },
      },
      { key: "mobile_no", label: "MOBILE NO", minWidth: "120px" },
      { key: "postal_no", label: "POSTAL NO", width: "100px" },
      { key: "city", label: "CITY", minWidth: "120px" },
      { key: "statename", label: "STATE", minWidth: "120px" },
      { key: "countryname", label: "COUNTRY", minWidth: "100px" },
      {
        key: "fax",
        label: "FAX",
        minWidth: "100px",
        render: (value) => value || "-",
      },
      {
        key: "web_address",
        label: "WEB ADDRESS",
        minWidth: "200px",
        render: (value) =>
          value ? (
            <a href={value} target="_blank" rel="noopener noreferrer">
              {value}
            </a>
          ) : (
            "-"
          ),
      },
      {
        key: "principal_first_name",
        label: "PRINCIPAL NAME",
        minWidth: "150px",
      },
      { key: "principal_email", label: "PRINCIPAL EMAIL", minWidth: "200px" },
      { key: "principal_mobile", label: "PRINCIPAL MOBILE", minWidth: "140px" },
    ],
    []
  );

  const handleRowClick = (row) => {
    console.log("Row clicked:", row);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <h1 className={styles.title}>SCHOOL LIST</h1>
        <div className={styles.headerActions}>
          <button
            type="button"
            className={styles.menuButton}
            aria-label="More options"
          >
            <i
              className="fa-solid fa-ellipsis-vertical"
              style={{ fontSize: "18px", color: "#333" }}
            />
          </button>
        </div>
      </div>

      {/* Error Message */}
      {error && (
        <div className={styles.errorMessage}>
          {error}
          <button onClick={fetchSchools} className={styles.retryButton}>
            Retry
          </button>
        </div>
      )}

      {/* Table */}
      <div className={styles.tableSection}>
        <CustomTable
          columns={columns}
          rows={paginatedSchools}
        //   onRowClick={handleRowClick}
          loading={loading}
          emptyMessage="No schools found"
          hoverable
          rowKeyField="id"
        />
      </div>

      {/* Pagination */}
      <div className={styles.paginationSection}>
        <CustomPagination
          page={page}
          limit={limit}
          total={schools.length}
          onPageChange={handlePageChange}
          showLimitSelector={false}
          siblingCount={3}
          showFirstLast
          showPrevNext
        />
      </div>
    </div>
  );
};

export default School;
